import { render } from "./button-tooltip.html?vue&type=template&id=1cedb3c7&scoped=true&ts=true"
import script from "./button-tooltip.ts?vue&type=script&lang=ts"
export * from "./button-tooltip.ts?vue&type=script&lang=ts"

import "./button-tooltip.scss?vue&type=style&index=0&id=1cedb3c7&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cedb3c7"]])

export default __exports__